/* eslint-disable */ import { applicationConfigComponent, assertNumber, attachSingleReferenceComponent, attributeSelectionComponent, childEntitySelectionComponent, composedOfComponent, memoEval, priceComponent, referenceComponent, staticPerspectiveCameraComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Legs, Top } from '../model/index.js';
export const tableComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'Table.$top', true).withEntity('Table'), Top, 'topId'),
    attachComponent.withComponent(composedOfComponent, '$top', true).withEntity('Table').attach(memoEval((self)=>[
            self.$top?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'Table.$legs', true).withEntity('Table'), Legs, 'legsId'),
    attachComponent.withComponent(composedOfComponent, '$legs', true).withEntity('Table').attach(memoEval((self)=>[
            self.$legs?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'default', true).withEntity('Table').attach(memoEval(()=>[], ()=>({
            layout: 'simple',
            initialGlobalUnit: 'cm',
            availableDimensions: []
        }))),
    attachComponent.withComponent(staticPerspectiveCameraComponent, 'default', true).withEntity('Table').attach(memoEval(()=>[], ()=>({
            priority: 1,
            fov: 35,
            near: 500,
            far: 20000,
            distance: 2800,
            azimuthAngle: -0.785,
            polarAngle: 1.2,
            minPolarAngle: 0,
            maxPolarAngle: 1.37,
            minDistance: 2200,
            maxDistance: 7000
        }))),
    attachComponent.withComponent(priceComponent, 'default', true).withEntity('Table').attach(memoEval((self)=>[
            self.$price
        ], ($price)=>({
            price: $price,
            currency: 'EUR'
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'height', true).withEntity('Table').attach(memoEval((self)=>[
            self.height,
            self.$heightOptions
        ], (height, $heightOptions)=>({
            value: height,
            options: $heightOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            height: state.value
        };
    }),
    attachComponent.withComponent(childEntitySelectionComponent, 'top', true).withEntity('Table').attach(memoEval((self)=>[
            self.topId,
            self.$topOptions
        ], (topId, $topOptions)=>({
            value: topId,
            options: $topOptions
        }))),
    attachComponent.withComponent(childEntitySelectionComponent, 'legs', true).withEntity('Table').attach(memoEval((self)=>[
            self.legsId,
            self.$legOptions
        ], (legsId, $legOptions)=>({
            value: legsId,
            options: $legOptions
        })))
];

//# sourceMappingURL=table.js.map